import { render, staticRenderFns } from "./html/form.html?vue&type=template&id=6542e9c9&scoped=true&"
import script from "./more-info-form.vue?vue&type=script&lang=js&"
export * from "./more-info-form.vue?vue&type=script&lang=js&"
import style0 from "./more-info-form.vue?vue&type=style&index=0&id=6542e9c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6542e9c9",
  null
  
)

export default component.exports